export default {
  hello: '¡Hola, {name}!',
  agenciesNoOptions: 'El usuario no pertenece a ninguna agencia',
  selectAgency: 'Selecciona tu agencia',
  agencies: 'Agencias',
  dashboard:'Panel'
};
